// third party imports
import MediaQuery from 'mediaquery';
import hasDom from 'has-dom';
import { getMediaValue } from './getMediaValue';
import { prepareConfig, buildResponsiveState } from './buildResponsiveState';
export var ResponsiveState = /*#__PURE__*/function () {
  function ResponsiveState(options) {
    var _prepareConfig = prepareConfig(options),
      config = _prepareConfig.config,
      mediaOrder = _prepareConfig.mediaOrder;
    this.options = config;
    this.mediaOrder = mediaOrder;
    this.mediaQueries = {
      breakpoints: MediaQuery.asObject(this.options.breakpoints),
      orientation: {
        portrait: '(orientation: portrait)',
        landscape: '(orientation: landscape)'
      }
    };
  }
  var _proto = ResponsiveState.prototype;
  _proto.calculate = function calculate(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      matchMedia = _ref.matchMedia,
      initialMediaType = _ref.initialMediaType,
      initialOrientation = _ref.initialOrientation;
    var mediaType = 'xs'; // mobile first!
    var orientation = this.options.orientation; // allow constructor defined orientation

    // If there is a dom and matchMedia then we assume we are workign client side with a window-like object
    // else we assume we are SSR and expect initial settings
    if (hasDom() && matchMedia) {
      mediaType = getMediaValue(matchMedia, this.mediaQueries.breakpoints, this.options.infinity);
      orientation = getMediaValue(matchMedia, this.mediaQueries.orientation, this.options.orientation);
    } else {
      if (initialMediaType) {
        mediaType = initialMediaType;
      }
      if (initialOrientation) {
        orientation = initialOrientation;
      }
    }
    return buildResponsiveState({
      mediaType: mediaType,
      orientation: orientation,
      config: this.options,
      mediaOrder: this.mediaOrder
    });
  };
  return ResponsiveState;
}();